/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import Route from '@ember/routing/route';

export default class WelcomeRoute extends Route {
  model() {
    return this.modelFor('apps.app.seatless-experience');
  }
}
